import TableData from "./table-data.component";

export default TableData;
